declare var gtag: Function;
import {
  Router,
  NavigationStart,
  NavigationCancel,
  NavigationEnd,
} from "@angular/router";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
@Injectable()
export class AnalyticsService {
  constructor(private router: Router) {}

  public event(eventName: string, params: {}) {
    // gtag('event', eventName, params);
  }

  public init() {
    this.listenForRouteChanges();

    try {
      // const script2 = document.createElement('noscript');
      // script2.innerHTML = `/* <![CDATA[ */
      //   var google_conversion_id = 812064834;
      //   var google_conversion_label = "tZCCCOa9nn8QwsCcgwM";
      //   var google_remarketing_only = false;
      //   /* ]]> */`;
      // document.head.appendChild(script2);
      // const script1 = document.createElement('script');
      // script1.async = true;
      // script1.src = `//www.googleadservices.com/pagead/conversion.js`
      // document.head.appendChild(script1);
      // const script3 = document.createElement('noscript');
      // script3.innerHTML = `<div style="display:inline;">
      // <img height="1" width="1" style="border-style:none;" alt="" src="//www.googleadservices.com/pagead/conversion/812064834/?label=tZCCCOa9nn8QwsCcgwM&amp;guid=ON&amp;script=0"/>
      // </div>`;
      // document.head.appendChild(script3);
    } catch (ex) {
      console.error("Error appending google analytics");
      console.error(ex);
    }
  }

  private listenForRouteChanges() {
    this.router.events.subscribe((event) => {
      // if (event instanceof NavigationEnd) {
      //   // gtag('config', environment.googleAnalyticsKey, {
      //   //   'page_path': event.urlAfterRedirects,
      //   // });
      //   // console.log('Sending Google Analytics hit for route', event.urlAfterRedirects);
      //   // console.log('Property ID', environment.googleAnalyticsKey);
      //      try {
      //     const script2 = document.createElement('noscript');
      // script2.innerHTML = `/* <![CDATA[ */
      //   var google_conversion_id = 812064834;
      //   var google_conversion_label = "tZCCCOa9nn8QwsCcgwM";
      //   var google_remarketing_only = false;
      //   /* ]]> */`;
      // document.head.appendChild(script2);
      // const script1 = document.createElement('script');
      // script1.async = true;
      // script1.src = `//www.googleadservices.com/pagead/conversion.js`
      // document.head.appendChild(script1);
      // const script3 = document.createElement('noscript');
      // script3.innerHTML = `<div style="display:inline;">
      // <img height="1" width="1" style="border-style:none;" alt="" src="//www.googleadservices.com/pagead/conversion/812064834/?label=tZCCCOa9nn8QwsCcgwM&amp;guid=ON&amp;script=0"/>
      // </div>`;
      // document.head.appendChild(script3);
      //   } catch (ex) {
      //     console.error('Error appending google analytics');
      //     console.error(ex);
      //   }
      // }
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/user/Desktop/rohini_india/angular/Srilanka-eta.org.lk/src/app/shared/services/analytics.service.ts